export default [
  {
    path: '/b2bhub/operacoes/pedido-vendas-padrao',
    name: 'pedidos-vendas-padrao',
    component: () => import('@/views/app/operacoes/pedidosVendasPadrao/pedidosVendas.vue'),
    meta: {
      pageTitle: 'Pedidos de Vendas',
      action: 'read',
      resource: 'Pedidos de Venda',
    },

  },
  {
    path: '/b2bhub/operacoes/pedido-vendas-padrao/create',
    name: 'pedidos-vendas-padrao-create',
    component: () => import('@/views/app/operacoes/pedidosVendasPadrao/createPedidos.vue'),
    meta: {
      pageTitle: 'Criar Pedido de Venda',
      action: 'read',
      resource: 'Pedidos de Venda',
    },

  },
  {
    path: '/b2bhub/operacoes/pedido-vendas-padrao/detalhes/:pedidoid/:clienteid',
    name: 'pedidos-vendas-padrao-detalhes',
    component: () => import('@/views/app/operacoes/pedidosVendasPadrao/detalhesPedidoVenda.vue'),
    meta: {
      pageTitle: 'Detalhes do Pedido de Venda',
      action: 'read',
      resource: 'Pedidos de Venda',
    },

  },
];
